export default __webpack_public_path__ + "static/media/4.7b7aa604.jpg";